import { createContext } from "solid-js";
const OverlayContext = createContext();
export default OverlayContext;
